import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Container,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Stepper from "../assets/Stepper.svg";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DaysUtils from "@date-io/dayjs";
import dayjs from "dayjs";
import TimePicker from "../components/TimePicker";
import { useHistory } from "react-router-dom";
import { getLocations, getCalendar } from "../services/ScheduleService";
import BookingSummary from "../components/booking-summary/BookingSummary";
import { BookingContext } from "../providers/BookingProvider";
import { AvailableDateType, LocationType } from "../services/types";
import { TimeSlotType } from "./types";

require("dayjs/locale/es");
dayjs.locale("es");

const AppointmentPage = () => {
  // global state booking
  const { booking, setBooking, organization } = useContext<any>(BookingContext);

  const history = useHistory();

  //  date the user want to take the service
  const [date, setDate] = useState<Date | undefined>(undefined);

  // periods of the day the service is available
  const [periods, setPeriods] = useState<TimeSlotType[]>([]);

  // comunas the service is available
  const [locations, setLocations] = useState<LocationType[]>([]);

  //   days of the month the service is available
  const [calendar, setCalendar] = useState<AvailableDateType[]>([]);

  // set minDate for disable Today
  const minDate = new Date(new Date().getTime() + 86400000);

  //   when user select a time for the service
  const onSelectTime = (time: TimeSlotType) => {
    // time = time.id !== booking.time?.id ? time : null;
    setBooking({ ...booking, time: time });
  };

  //   when user select other date for the service
  const onChangeDate = (date) => {
    setDate(date);
    const formattedDate = dayjs(date)
      .format("YYYY/MM/DD")
      .replace("/", "-")
      .replace("/", "-");

    const selectedDayObject = calendar.find((el) => el.date === formattedDate);

    setPeriods(selectedDayObject.blockServices);

    setBooking({ ...booking, date: formattedDate });
  };

  // select comuna where the service is available
  const onSelectLocation = (location) => {
    setBooking({ ...booking, location: location });
  };

  //   go to next page (after pressing continue button)
  const nextPage = () => {
    history.push("/c/pacientes");
  };

  const previuousPage = () => {
    history.go(-1);
  };

  // get periods of the day the service is available
  // useEffect(() => {
  //   async function fetchData() {
  //     // const result = await getPeriods(organization.id);
  //     const result = [];
  //     const times = result.map((period) => {
  //       return {
  //         id: period.id,
  //         description: `${period.hourStart} a ${period.hourEnd} hs`,
  //         isAvailable: false,
  //       };
  //     });
  //     // setPeriods(times);
  //   }

  //   fetchData();
  // }, []);

  // get initial locations the service is available
  useEffect(() => {
    async function fetchData() {
      const result = await getLocations(organization.id);
      setLocations(result);
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //   get initial days the service is available???
  useEffect(() => {
    async function fetchData() {
      pullCalendar(dayjs());
    }
    fetchData();
  }, []);

  //   each time monht or year changes, get the near date available
  // useEffect(() => {
  //   if (calendar.length > 0) {
  //     getNearDate();
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [calendar]);

  //   each time the date changes, get the times the service is available
  // useEffect(() => {
  //   pullPeriods();
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [date]);

  //   each time the periods changes, update the global booking
  // useEffect(() => {
  //   const period = periods.find((period) => period.id === booking?.time?.id);
  //   setBooking({
  //     ...booking,
  //     date: date,
  //     time: period?.isAvailable ? period : null,
  //   });
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [periods]);

  //   when user change the month or year on calendar
  const onChangeCalendar = async (date) => {
    pullCalendar(date);
  };

  //   get days of the month the service is available
  const pullCalendar = async (date) => {
    date = dayjs(date);
    // const year = parseInt(date.format("YYYY"));
    const month = parseInt(date.format("MM"));

    // get availables days of the months from database
    const result = await getCalendar(month, organization.id);

    setCalendar(result);
  };

  //   get periods of the month the service is available
  // const pullPeriods = () => {
  //   let calendarPeriods = calendar.filter(
  //     (day) => day.date === dayjs(date).format("YYYY-MM-DD")
  //   );
  //   // const formattedPeriods = calendarPeriods.map((day) => day.periods[0]);
  //    const formattedPeriods = [];
  //   // if (calendarPeriods.length > 0) calendarPeriods = calendarPeriods[0];
  //   calendarPeriods["periods"] = formattedPeriods;
  //   setBooking({ ...booking, calendar: calendarPeriods });
  // const times = periods.map((period) => {
  //   const isAvailable =
  //     // calendarPeriods?.periods.find(
  //     //   (calendarPeriod) => calendarPeriod?.period?.id === period.id
  //     // )?.slots > 0;
  //     true;
  //   return {
  //     ...period,
  //     isAvailable: isAvailable,
  //   };
  // });
  // setPeriods(times);
  // };

  //   get near date available
  // const getNearDate = () => {
  // const today = dayjs().format("YYYY-MM-DD");
  // let nearDate = calendar.find(
  //   (schedule) => dayjs(schedule.date) >= dayjs(today)
  // ).date;
  // nearDate =
  //   nearDate ??
  //   calendar
  //     .reverse()
  //     .find((schedule) => dayjs(schedule.date) <= dayjs(today))?.date;
  // setDate(nearDate);
  // };

  // get periods of the day the service is available
  // useEffect(() => {
  //   setPeriods(selectedCalendarObject);
  // }, [date])

  // disable days without availability
  const disableDays = (date) => {
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    const shouldDisable = calendar.some(
      (schedule) => schedule.date === formattedDate
    );
    return !shouldDisable;
  };

  return (
    <Container
      maxWidth={false}
      style={{ backgroundColor: "#F0F2F9", paddingTop: 60, height: "100vh" }}
    >
      <Container>
        <Grid container spacing={3}>
          {/* appointment options to select */}
          <Grid item xs={12} sm={8}>
            <div
              style={{
                backgroundColor: "#FFF",
                padding: "4rem",
                borderRadius: 12,
              }}
            >
              <Grid container spacing={1} justify={"center"}>
                {/* image of stepper */}
                <Grid item md={12}>
                  <img
                    src={Stepper}
                    style={{
                      margin: "auto",
                      display: "block",
                      width: "100%",
                      height: "auto",
                    }}
                    alt="stepper"
                  />
                  <Typography
                    variant={"h5"}
                    component={"h2"}
                    style={{ marginTop: "1.5rem", color: "#6A6D81" }}
                  >
                    Selecciona tu comuna:
                  </Typography>
                </Grid>

                {/* comuna select */}
                <Grid item md={12} style={{ marginBottom: "0rem" }}>
                  <Autocomplete
                    options={locations}
                    getOptionLabel={(option) => option.name}
                    onChange={(event, newValue) => onSelectLocation(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        placeholder="Busca tu comuna"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>

                {/* help text to choose date and time */}
                <Grid item md={12}>
                  <Typography
                    variant={"h5"}
                    component={"h2"}
                    style={{ color: "#6A6D81" }}
                  >
                    Elije un día y hora para tu servicio:
                  </Typography>
                </Grid>

                {/* date picker from calendar*/}
                <Grid item xs={12} sm={7}>
                  {/* date picker from calendar */}
                  <MuiPickersUtilsProvider utils={DaysUtils}>
                    <KeyboardDatePicker
                      disableToolbar={false}
                      label="Elige un día"
                      autoOk
                      minDate={minDate}
                      minDateMessage="Este día no está disponible"
                      format="DD/MM/YYYY"
                      openTo="date"
                      value={date}
                      onChange={(d) => onChangeDate(d)}
                      shouldDisableDate={disableDays}
                      onMonthChange={onChangeCalendar}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      InputProps={{ readOnly: true }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>

                {/* date selected and time picker */}
                <Grid item xs={12} sm={5}>
                  {/* <div
                    style={{
                      borderRadius: "4px",
                      border: "1px solid #D4D2D8",
                      textAlign: "center",
                      marginBottom: "2rem",
                    }}
                  >
                    <Typography
                      variant={"body2"}
                      component={"body2"}
                      style={{ color: "#597EF7" }}
                    >
                      Turno seleccionado
                    </Typography>
                    <Typography variant={"body1"}>
                      {dayjs(date).format("DD MMMM YYYY")}
                    </Typography>
                  </div> */}

                  {/* time picker for the service */}
                  <Typography
                    variant={"body1"}
                    component={"h2"}
                    style={{ color: "#597EF7" }}
                  >
                    Franja horaria:
                  </Typography>
                  {/* time picker */}
                  <TimePicker
                    times={periods}
                    selectedTime={booking.time}
                    onSelectTime={onSelectTime}
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>

          {/* bookging summary */}
          <Grid item xs={12} sm={4}>
            <BookingSummary />
          </Grid>

          {/* continue button */}
          <Grid item xs={12}>
            <Button
              variant={"contained"}
              color={"primary"}
              style={{ float: "right" }}
              onClick={nextPage}
              disabled={!booking.location || !booking.date || !booking.time}
            >
              Continuar <ArrowRightAltIcon />
            </Button>
            <Button
              variant={"contained"}
              color={"secondary"}
              style={{ float: "left" }}
              onClick={previuousPage}
            >
              Volver
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Container>
  );
};

export default AppointmentPage;
